var exports = {
  "H": "xa15a2ab7--3fbc5e--btn",
  "C": "xa15a2ab7--3fbc5e--btn-disabled",
};

module.exports = exports;
